import * as React from 'react';
import withRoot from '../modules/withRoot';
import NavBar from '../modules/views/NavBar';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import PageHead from '../modules/views/PageHead';
import Sections from './Sections';
import PageMeta from '../modules/components/PageMeta';

function Flow() {
  return (
    <React.Fragment>
      <PageMeta
        title="家づくりの流れ"
        description="飯田建築の家づくりの流れ。ご相談・現地調査から設計・見積もり、契約、着工、お引渡しまで6つのステップでご案内します。打ち合わせ・見積は無料です。"
        path="/flow"
      />
      <NavBar />
      <PageHead eyebrow="Flow" title="家づくりの流れ" lead="ご相談からお引渡しまで、6つのステップでご案内します。" />
      <Sections />
      <CtaBand title="まずは「Step 01」から、無料相談。" />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Flow);
